export const translations = {
  en: {
    "nav.parties": "Parties",
    "nav.clubs": "Speaking clubs",
    "nav.classes": "Classes",
    "nav.about": "About",
    "nav.book": "Book a class",
    "hero.eyebrow": "KNDLA® — nights, words, flame",
    "hero.line1": "PARTIES THAT",
    "hero.line2": "SPEAK",
    "hero.line3": "LOUDER.",
    "hero.sub": "We throw parties, run speaking clubs and teach Spanish, English & Portuguese. Come for the conversation — stay for the party.",
    "hero.ctaParties": "See the next parties",
    "hero.ctaClasses": "Book a class",
    "hero.scroll": "Scroll",
    "marquee.parties": "PARTIES",
    "marquee.clubs": "SPEAKING CLUBS",
    "marquee.spanish": "SPANISH",
    "marquee.english": "ENGLISH",
    "marquee.portuguese": "PORTUGUESE",
    "parties.eyebrow": "01 — Nights",
    "parties.title": "Upcoming parties",
    "parties.sub": "Pick a night, choose how many spots, and we sort the payment with you on Telegram. No accounts, no queues.",
    "parties.spots": "{n} spots",
    "parties.free": "Free",
    "parties.getTickets": "Get tickets",
    "parties.empty": "New nights are being cooked up. Follow us on Telegram to hear first.",
    "modal.howMany": "How many?",
    "modal.total": "Total",
    "modal.pay": "Pay via Telegram",
    "modal.note": "You'll land in our Telegram (@{handle}) with your order pre-written — we confirm your spots and share the transfer details there.",
    "modal.botNote": "The official KNDLA bot will open this event with your selected quantity. The bot confirms the final price and payment details.",
    "parties.unavailable": "Tickets not available",
    "modal.less": "One less ticket",
    "modal.more": "One more ticket",
    "clubs.eyebrow": "02 — Words",
    "clubs.title": "Speaking clubs",
    "clubs.sub": "Free conversation nights in bars, not classrooms. Show up, order a drink, speak another language for two hours. Tap a date to save your spot on Telegram.",
    "clubs.freeEntry": "Free entry",
    "clubs.note": "Spots are limited — clubs fill fast after parties",
    "clubs.empty": "Next club dates are being scheduled — check back soon.",
    "classes.eyebrow": "03 — Classes",
    "classes.title": "Learn a language",
    "classes.sub": "Small groups, teachers we actually hang out with. Pick a language, grab a time that fits, book your spot.",
    "lang.spanish.blurb": "From hola to holding court at the bar.",
    "lang.english.blurb": "The lingua franca of every afterparty.",
    "lang.portuguese.blurb": "Saudade, bossa nova and real conversation.",
    "lang.spanish.name": "Spanish",
    "lang.english.name": "English",
    "lang.portuguese.name": "Portuguese",
    "classes.seeTimes": "See times",
    "classes.selected": "Selected",
    "classes.availableTimes": "available times",
    "classes.empty": "No open {lang} dates right now — new ones land every week.",
    "classes.full": "Full",
    "classes.left": "{n} left",
    "classes.pickHint": "Pick a time above to book your spot",
    "classes.booking": "Booking",
    "classes.namePh": "Your name",
    "classes.emailPh": "Email",
    "classes.phonePh": "Phone / Telegram (optional)",
    "classes.confirm": "Confirm booking",
    "classes.bookingBusy": "Booking…",
    "classes.successTitle": "You're in, {name}!",
    "classes.successBody": "{lang} class · {slot}. We'll confirm everything by email shortly.",
    "classes.bookAnother": "Book another class",
    "toast.booked": "Class booked — see you there!",
    "toast.bookFail": "Could not book that slot.",
    "about.eyebrow": "04 — The idea",
    "about.titleA": "KNDLA is what happens when a ",
    "about.titleB": "party crew",
    "about.titleC": " starts a ",
    "about.titleD": "language school",
    "about.titleE": ". Or the other way around.",
    "about.body": "Languages stick when they're attached to memories — the conversation at 2am, the joke that finally landed, the friend you made waiting for a drink. So we build the nights first, and the learning follows.",
    "about.stat1": "Languages on rotation",
    "about.stat2": "Parties every year",
    "about.stat3": "Community, zero snobbery",
    "footer.tagline": "Parties, speaking clubs and language classes. Come for the conversation, stay for the party.",
    "footer.explore": "Explore",
    "footer.linkParties": "Upcoming parties",
    "footer.linkClubs": "Speaking clubs",
    "footer.linkClasses": "Language classes",
    "footer.linkAbout": "About KNDLA",
    "footer.findUs": "Find us",
    "footer.channel": "Telegram channel — @KNDLA404",
    "footer.rights": "© 2026 KNDLA — All flames reserved.",
  },
  es: {
    "nav.parties": "Fiestas",
    "nav.clubs": "Clubs de conversación",
    "nav.classes": "Clases",
    "nav.about": "Nosotros",
    "nav.book": "Reserva una clase",
    "hero.eyebrow": "KNDLA® — noches, palabras, fuego",
    "hero.line1": "FIESTAS QUE",
    "hero.line2": "HABLAN",
    "hero.line3": "MÁS FUERTE.",
    "hero.sub": "Organizamos fiestas, clubs de conversación y clases de español, inglés y portugués. Ven por la conversación — quédate por la fiesta.",
    "hero.ctaParties": "Ver próximas fiestas",
    "hero.ctaClasses": "Reserva una clase",
    "hero.scroll": "Desliza",
    "marquee.parties": "FIESTAS",
    "marquee.clubs": "CLUBS DE CONVERSACIÓN",
    "marquee.spanish": "ESPAÑOL",
    "marquee.english": "INGLÉS",
    "marquee.portuguese": "PORTUGUÉS",
    "parties.eyebrow": "01 — Noches",
    "parties.title": "Próximas fiestas",
    "parties.sub": "Elige una noche, cuántas entradas quieres, y cerramos el pago contigo por Telegram. Sin cuentas, sin colas.",
    "parties.spots": "{n} plazas",
    "parties.free": "Gratis",
    "parties.getTickets": "Entradas",
    "parties.empty": "Estamos cocinando nuevas noches. Síguenos en Telegram para enterarte primero.",
    "modal.howMany": "¿Cuántas?",
    "modal.total": "Total",
    "modal.pay": "Pagar por Telegram",
    "modal.note": "Entrarás en nuestro Telegram (@{handle}) con tu pedido ya escrito — confirmamos tus entradas y te pasamos los datos para la transferencia.",
    "modal.botNote": "El bot oficial abrirá esta fiesta con la cantidad elegida. Allí confirmarás el precio final y los datos de pago.",
    "parties.unavailable": "Entradas no disponibles",
    "modal.less": "Una entrada menos",
    "modal.more": "Una entrada más",
    "clubs.eyebrow": "02 — Palabras",
    "clubs.title": "Clubs de conversación",
    "clubs.sub": "Noches de conversación gratis en bares, no en aulas. Ven, pide una copa y habla otro idioma durante dos horas. Toca una fecha para reservar tu sitio por Telegram.",
    "clubs.freeEntry": "Entrada gratis",
    "clubs.note": "Plazas limitadas — los clubs se llenan rápido después de las fiestas",
    "clubs.empty": "Estamos cerrando las próximas fechas — vuelve pronto.",
    "classes.eyebrow": "03 — Clases",
    "classes.title": "Aprende un idioma",
    "classes.sub": "Grupos pequeños y profes con los que de verdad nos vamos de fiesta. Elige idioma, hora y reserva tu plaza.",
    "lang.spanish.blurb": "De «hola» a liarla en la barra.",
    "lang.english.blurb": "La lengua franca de cada after.",
    "lang.portuguese.blurb": "Saudade, bossa nova y conversación de verdad.",
    "lang.spanish.name": "Español",
    "lang.english.name": "Inglés",
    "lang.portuguese.name": "Portugués",
    "classes.seeTimes": "Ver horarios",
    "classes.selected": "Elegido",
    "classes.availableTimes": "horarios disponibles",
    "classes.empty": "Ahora mismo no hay fechas de {lang} — caen nuevas cada semana.",
    "classes.full": "Lleno",
    "classes.left": "quedan {n}",
    "classes.pickHint": "Elige un horario arriba para reservar",
    "classes.booking": "Reserva",
    "classes.namePh": "Tu nombre",
    "classes.emailPh": "Correo electrónico",
    "classes.phonePh": "Teléfono / Telegram (opcional)",
    "classes.confirm": "Confirmar reserva",
    "classes.bookingBusy": "Reservando…",
    "classes.successTitle": "¡Dentro, {name}!",
    "classes.successBody": "Clase de {lang} · {slot}. Te confirmamos todo por email en breve.",
    "classes.bookAnother": "Reservar otra clase",
    "toast.booked": "¡Clase reservada — nos vemos!",
    "toast.bookFail": "No se pudo reservar ese horario.",
    "about.eyebrow": "04 — La idea",
    "about.titleA": "KNDLA es lo que pasa cuando un ",
    "about.titleB": "grupo de fiesta",
    "about.titleC": " monta una ",
    "about.titleD": "escuela de idiomas",
    "about.titleE": ". O al revés.",
    "about.body": "Los idiomas se quedan cuando van pegados a recuerdos — la conversación a las 2 de la mañana, el chiste que por fin salió, el amigo que hiciste esperando una copa. Por eso primero montamos la fiesta; el aprendizaje viene detrás.",
    "about.stat1": "Idiomas en rotación",
    "about.stat2": "Fiestas cada año",
    "about.stat3": "Comunidad, cero postureo",
    "footer.tagline": "Fiestas, clubs de conversación y clases de idiomas. Ven por la conversación, quédate por la fiesta.",
    "footer.explore": "Explora",
    "footer.linkParties": "Próximas fiestas",
    "footer.linkClubs": "Clubs de conversación",
    "footer.linkClasses": "Clases de idiomas",
    "footer.linkAbout": "Sobre KNDLA",
    "footer.findUs": "Encuéntranos",
    "footer.channel": "Canal de Telegram — @KNDLA404",
    "footer.rights": "© 2026 KNDLA — Todas las llamas reservadas.",
  },
  ru: {
    "nav.parties": "Вечеринки",
    "nav.clubs": "Разговорные клубы",
    "nav.classes": "Занятия",
    "nav.about": "О нас",
    "nav.book": "Записаться",
    "hero.eyebrow": "KNDLA® — ночи, слова, огонь",
    "hero.line1": "ВЕЧЕРИНКИ,",
    "hero.line2": "КОТОРЫЕ",
    "hero.line3": "ГРОМЧЕ ВСЕХ.",
    "hero.sub": "Мы устраиваем вечеринки, ведём разговорные клубы и учим испанскому, английскому и португальскому. Приходи ради разговора — останься ради вечеринки.",
    "hero.ctaParties": "Ближайшие вечеринки",
    "hero.ctaClasses": "Записаться на занятие",
    "hero.scroll": "Листай",
    "marquee.parties": "ВЕЧЕРИНКИ",
    "marquee.clubs": "РАЗГОВОРНЫЕ КЛУБЫ",
    "marquee.spanish": "ИСПАНСКИЙ",
    "marquee.english": "АНГЛИЙСКИЙ",
    "marquee.portuguese": "ПОРТУГАЛЬСКИЙ",
    "parties.eyebrow": "01 — Ночи",
    "parties.title": "Ближайшие вечеринки",
    "parties.sub": "Выбери ночь и количество мест — оплату решим с тобой в Telegram. Без аккаунтов и очередей.",
    "parties.spots": "{n} мест",
    "parties.free": "Бесплатно",
    "parties.getTickets": "Билеты",
    "parties.empty": "Готовим новые ночи. Подпишись на Telegram, чтобы узнать первым.",
    "modal.howMany": "Сколько?",
    "modal.total": "Итого",
    "modal.pay": "Оплатить в Telegram",
    "modal.note": "Ты попадёшь в наш Telegram (@{handle}) с уже написанным заказом — подтвердим места и отправим реквизиты для перевода.",
    "modal.botNote": "Официальный бот откроет эту вечеринку с выбранным количеством билетов. Цена и оплата подтверждаются в боте.",
    "parties.unavailable": "Билеты недоступны",
    "modal.less": "На один билет меньше",
    "modal.more": "На один билет больше",
    "clubs.eyebrow": "02 — Слова",
    "clubs.title": "Разговорные клубы",
    "clubs.sub": "Бесплатные разговорные вечера в барах, а не в классах. Приходи, закажи напиток и говори два часа на другом языке. Нажми на дату, чтобы занять место через Telegram.",
    "clubs.freeEntry": "Вход свободный",
    "clubs.note": "Мест мало — после вечеринок клубы заполняются быстро",
    "clubs.empty": "Новые даты скоро появятся — загляни позже.",
    "classes.eyebrow": "03 — Занятия",
    "classes.title": "Выучи язык",
    "classes.sub": "Маленькие группы и преподаватели, с которыми мы сами тусуемся. Выбери язык, время и забронируй место.",
    "lang.spanish.blurb": "От «hola» до разговоров у барной стойки.",
    "lang.english.blurb": "Язык любого афтепати.",
    "lang.portuguese.blurb": "Саудаде, босанова и настоящие разговоры.",
    "lang.spanish.name": "Испанский",
    "lang.english.name": "Английский",
    "lang.portuguese.name": "Португальский",
    "classes.seeTimes": "Расписание",
    "classes.selected": "Выбрано",
    "classes.availableTimes": "доступное время",
    "classes.empty": "Сейчас нет открытых дат ({lang}) — новые появляются каждую неделю.",
    "classes.full": "Полно",
    "classes.left": "осталось {n}",
    "classes.pickHint": "Выбери время выше, чтобы записаться",
    "classes.booking": "Запись",
    "classes.namePh": "Твоё имя",
    "classes.emailPh": "Эл. почта",
    "classes.phonePh": "Телефон / Telegram (необязательно)",
    "classes.confirm": "Подтвердить",
    "classes.bookingBusy": "Записываем…",
    "classes.successTitle": "Ты в деле, {name}!",
    "classes.successBody": "Занятие: {lang} · {slot}. Скоро подтвердим всё по почте.",
    "classes.bookAnother": "Записать ещё",
    "toast.booked": "Занятие забронировано — до встречи!",
    "toast.bookFail": "Не удалось забронировать.",
    "about.eyebrow": "04 — Идея",
    "about.titleA": "KNDLA — это когда ",
    "about.titleB": "тусовка",
    "about.titleC": " открывает ",
    "about.titleD": "языковую школу",
    "about.titleE": ". Или наоборот.",
    "about.body": "Языки запоминаются, когда они привязаны к воспоминаниям — разговор в два ночи, шутка, которая наконец зашла, друг, с которым познакомился у бара. Поэтому сначала мы делаем вечеринку, а учёба приходит следом.",
    "about.stat1": "Языка в ротации",
    "about.stat2": "Вечеринок в год",
    "about.stat3": "Тусовка без пафоса",
    "footer.tagline": "Вечеринки, разговорные клубы и языковые занятия. Приходи ради разговора, останься ради вечеринки.",
    "footer.explore": "Разделы",
    "footer.linkParties": "Ближайшие вечеринки",
    "footer.linkClubs": "Разговорные клубы",
    "footer.linkClasses": "Языковые занятия",
    "footer.linkAbout": "О KNDLA",
    "footer.findUs": "Мы на связи",
    "footer.channel": "Telegram-канал — @KNDLA404",
    "footer.rights": "© 2026 KNDLA — Все огни защищены.",
  },
};

export const LOCALES = { en: "en-GB", es: "es-ES", ru: "ru-RU" };
